import Modal from "../../../../../components/Modal";
import { Title, Text, SmallText, SuccessIcon, PrimaryButton, SecondaryButton, Actions, Flex } from "./styles";
import { connect, useDispatch } from "react-redux";
import { hideModal } from "../../../../../store/actions/modal";
import { useHistory } from "react-router";
import { Icon } from "../../../../../components/Icon/styles";
import checkIcon from "../../../../../assets/icons/check-bold.svg";

const Component = ({ postInformation, groupInformation }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const libraryUrl = groupInformation?.group_type === "free_experience"
    ? `/dashboard/community/events/${groupInformation?.id}/posts`
    : `/dashboard/${groupInformation?.group_type}/${groupInformation?.id}/posts`;

  const previewUrl = `/group/${groupInformation?.id}/p/${postInformation?.id}`;

  const handleGoToLibrary = () => {
    dispatch(hideModal());
    history.push(libraryUrl);
  };

  const handleGoToPreview = () => {
    dispatch(hideModal());
    window.open(previewUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <Modal
      name="modal-confirm-post-edition"
      width="320"
      onClose={() => dispatch(hideModal())}
      showClose={true}
    >
      <Flex>
        <SuccessIcon>
          <Icon icon={checkIcon} size="55px" color="#4CA154" />
        </SuccessIcon>
      </Flex>

      <div style={{ height: 24 }} />

      <Title>¡Artículo editado con éxito!</Title>

      <div style={{ height: 8 }} />

      <Text>
        Los cambios ya están disponibles para tu comunidad.
      </Text>

      <div style={{ height: 24 }} />

      <Actions>
        <PrimaryButton
          options={{
            type: "filled",
            size: "md",
            skin: "purple",
          }}
          onClick={handleGoToLibrary}
        >
          Volver a la biblioteca
        </PrimaryButton>

        <SecondaryButton
          options={{
            type: "outline",
            size: "md",
            skin: "black",
          }}
          onClick={handleGoToPreview}
        >
          Ver vista previa
        </SecondaryButton>
      </Actions>

      <div style={{ height: 8 }} />

      <SmallText>
        Podés volver a la biblioteca o revisar cómo ven el contenido tus miembros.
      </SmallText>
    </Modal>
  );
};

const state = ({ postStore, groupStore }) => {
  const { data: postInformation } = postStore.post;
  const { data: groupInformation } = groupStore.group;

  return {
    postInformation,
    groupInformation,
  };
};

export default connect(state)(Component);
